import React from 'react'

import { Field } from 'formik'

import { Form, Col, Row } from '_zari/core'

import { TiposPreventivoCorrectivoConstant } from 'constants/index'

const TipoPreventivoCorrectivoFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Row>
      <Col md={4} />
      <Col md={8}>
        <Field name='tipoPreventivoCorrectivo'>
          {({ field }) => (
            <Form.Radio
              {...field}
              value={TiposPreventivoCorrectivoConstant.PREVENTIVO}
              checked={iValue === TiposPreventivoCorrectivoConstant.PREVENTIVO}
              disabled={fIsSubmitting}
              id='checkbox-tipoPreventivo'
              label='Preventivo'
            />
          )}
        </Field>
        <Field name='tipoPreventivoCorrectivo'>
          {({ field }) => (
            <Form.Radio
              {...field}
              value={TiposPreventivoCorrectivoConstant.CORRECTIVO}
              checked={iValue === TiposPreventivoCorrectivoConstant.CORRECTIVO}
              disabled={fIsSubmitting}
              id='checkbox-tipoCorrectivo'
              label='Correctivo'
            />
          )}
        </Field>
      </Col>
    </Row>
  )
}

export default React.memo(TipoPreventivoCorrectivoFormGroup)
